import type { JobComponent } from "@repo/design-system/lib/client-registry";
import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import ApplicationProcessEonSverige from "~/components/job-page/subclients/sverige/application-process-eon-sverige";
import CompanyEonSverige from "~/components/job-page/subclients/sverige/company-eon-sverige";
import ContactEonSverige from "~/components/job-page/subclients/sverige/contact-eon-sverige";
import HeaderImageEonSverige from "~/components/job-page/subclients/sverige/headerimage-eon-sverige";
import IntroEonSverige from "~/components/job-page/subclients/sverige/intro-eon-sverige";
import JobAdTemplateEonSverige from "~/components/job-page/subclients/sverige/jobad-template-eon-sverige";
import StickyContactEonSverige from "~/components/job-page/subclients/sverige/sticky-contact-eon-sverige";
import TeaserBarJobpageEonSverige from "~/components/job-page/subclients/sverige/teaserbar-jobpage-eon-sverige";

export const sverigeDefault = createSubtemplate<SectionKey>({
  name: "sverige",
  trigger: () => true,
  showProd: true,
  config: {
    overrides: {
      stickyContact: StickyContactEonSverige as JobComponent,
      headerImage: HeaderImageEonSverige as JobComponent,
      jobDescription: JobAdTemplateEonSverige as JobComponent,
      contact: ContactEonSverige as JobComponent,
      applicationProcess: ApplicationProcessEonSverige as JobComponent,
      companyInfo: CompanyEonSverige as JobComponent,
      // Custom sections not in base
      intro: IntroEonSverige as JobComponent,
      teaserBar: TeaserBarJobpageEonSverige as JobComponent,
    },
    sections: [
      "stickyContact",
      "headerImage",
      "breadcrumb",
      "intro",
      "jobDescription",
      "contact",
      "applicationProcess",
      "companyInfo",
      "teaserBar",
      "printView",
    ],
  },
});
